<template>
<div class="chapter">
<div class="inner_page">
<p class="ch_img"><img alt="IMages" src="images/ch1.jpg"/></p>
<p class="noindent">Jack’s parents hovered over the sofa, shoving clothes into duffel bags. Jack tiptoed across the living room. Standing behind them, he whispered, “What are you doing? Running away?”</p>
<p class="indent">Richard and Claire Berenson whirled to face Jack. They looked as if they had been caught robbing a bank.</p>
<p class="indent">“You <i>are</i> running away!” Jack said. “Without me?” Jack thought his family had finally settled into a comfortable routine. They were back in his old neighborhood in Pennsylvania, with the Berenson Family Rules hung on the refrigerator.</p>
<p style="text-align: center;"><img alt="IMages" src="images/img_2.jpg"/></p>
<p class="indent">“Jack,” his dad said, “there you are. Right there behind us.”</p>
<p class="indent">“Don’t be a goose, Jack,” his mom said. “Of course we’re not running away. If we ever go on the run, you’ll be the first thing we pack. We’re just—”</p>
<p class="indent">“Organizing,” his dad said.</p>
<p class="indent">“Organizing?” Jack said. That wasn’t likely. “Tell me what’s going on.”</p>
<p class="indent">“Oh, we did try to tell you,” his mom said.</p>
<p class="indent">“Spelled it out every which way,” his dad added.</p>
<p class="indent">“Remember, Jack,” his mom said, “when we went to the Renaissance Fair for dinner? Right through the whole jousting tournament, your dad and I observed that life is an adventure. Don’t you adore airports, we asked, and aren’t elephants amazing, and isn’t camping divine?”</p>
<p class="indent">Jack did remember that. He had told the medieval serving wench not to give them any more mead. “What were you trying to tell me?”</p>
<p class="indent">His mom blurted out, “We’re going to Africa!”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?2d87d814